/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  UserFlagsUserControllerApplyMutationRequest,
  UserFlagsUserControllerApplyMutationResponse,
  UserFlagsUserControllerApply401,
  UserFlagsUserControllerApply404,
} from '../types/UserFlagsUserControllerApply.ts';

function getUserFlagsUserApplyUrl() {
  const res = { method: 'POST', url: `/api/user/user-flags/apply` as const };
  return res;
}

/**
 * {@link /api/user/user-flags/apply}
 */
export async function userFlagsUserApply(
  data: UserFlagsUserControllerApplyMutationRequest,
  config: Partial<RequestConfig<UserFlagsUserControllerApplyMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    UserFlagsUserControllerApplyMutationResponse,
    ResponseErrorConfig<UserFlagsUserControllerApply401 | UserFlagsUserControllerApply404>,
    UserFlagsUserControllerApplyMutationRequest
  >({ method: 'POST', url: getUserFlagsUserApplyUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
